var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.33 16.09 1.2-1.19-2.8-2.8 2.8-2.78-1.2-1.18-4 3.96 4 3.99Zm5.34 0 4.02-3.99-4-3.96-1.19 1.18 2.8 2.78-2.83 2.8 1.2 1.19ZM3.67 22c-.47 0-.86-.16-1.18-.48A1.58 1.58 0 0 1 2 20.35V3.85c0-.46.16-.85.49-1.17.32-.32.71-.48 1.18-.48h5.7c.08-.64.38-1.17.88-1.58C10.75.2 11.33 0 12 0c.67 0 1.25.2 1.75.62.5.41.8.94.89 1.58h5.7c.46 0 .85.16 1.17.48.33.32.49.71.49 1.17v16.5c0 .46-.16.85-.49 1.17-.32.32-.71.48-1.18.48H3.67Zm0-1.65h16.66V3.85H3.67v16.5ZM12 3.38c.26 0 .49-.1.68-.29a.92.92 0 0 0 0-1.34.94.94 0 0 0-.68-.3c-.26 0-.49.1-.68.3a.92.92 0 0 0 0 1.34c.2.2.42.3.68.3ZM3.67 20.35V3.85v16.5Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.d47237d8b8b7fba47c9d07a324d85516.svg";
export { ForwardRef as ReactComponent };